import React from 'react';

function Logo({ size = 40, color = "#FFD600" }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Sun rays */}
      <path 
        d="M50 10L55 25L70 25L60 35L65 50L50 40L35 50L40 35L30 25L45 25L50 10Z" 
        fill={color}
      />
      {/* Cloud */}
      <path 
        d="M25 60C25 60 15 60 15 70C15 80 25 80 25 80H75C75 80 85 80 85 70C85 60 75 60 75 60C75 45 65 35 50 35C35 35 25 45 25 60Z" 
        fill={color}
        fillOpacity="0.8"
      />
      {/* T letter */}
      <path 
        d="M40 45H60V50H55V65H45V50H40V45Z" 
        fill={color}
      />
    </svg>
  );
}

export default Logo; 